import { render, staticRenderFns } from "./GistPublishModal.vue?vue&type=template&id=0b506c1d&"
import script from "./GistPublishModal.vue?vue&type=script&lang=js&"
export * from "./GistPublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GistPublishModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GistPublishModal.vue
// module id = 2185
// module chunks = 1